export default {
  'kaburagi': {
    type: 'staff',
    title: '監督',
    name: '鏑木ひろ',
    comment: '日常的に騙し騙されてる（？）紳士淑女の皆様、おまんたせいたしました。脚本担当の古沢氏が作り上げた『信用詐欺』を題材にしたアニメ作品で御座います！世界を股にかける、懐かしくも新しい世界観。まあまあ…いや、相当の自信作です。珈琲でも飲みながら、出来上がりをお待ちください。'
  },
  'kosawa': {
    type: 'staff',
    title: '脚本・シリーズ構成',
    name: '古沢良太',
    comment: '私の初めてのオリジナルアニメーションです。アニメばかり見ていた少年時代の自分に向けて作ったつもりです。大きな挑戦でしたが、素晴らしいスタジオで、鏑木さん、貞本さんはじめ超一流のスタッフに助けられ、なんとか最後まで書くことができました。今はどんな出来上がりになるのかワクワクしています。多くの皆さんに楽しんでいただけたら幸いです。'
  },
  'sadamoto': {
    type: 'staff',
    title: 'キャラクターデザイン',
    name: '貞本義行',
    comment: '企画の段階で頂いた古沢さんの脚本の完成度が高く、夢中で読ませて頂きました。僕の今回の作業はその時の第一印象で頭に浮かんだキャライメージを元に鏑木監督や他スタッフの要望を聞き入れながら長く皆様に愛していただける実存感のあるキャラクターデザインを模索するというものでした。個人的には大好きなテイストの作品でもあるのでチャレンジの多い作業も楽しく、いままで関わってきたどの作品とも毛色の異なった作品となりました。あとは皆様に画面の前で楽しんでいただければと思います。'
  },
  'kato': {
    type: 'staff',
    title: 'サブキャラクターデザイン・総作画監督',
    name: '加藤寛崇'
  },
  'asano': {
    type: 'staff',
    title: '総作画監督',
    name: '浅野恭司'
  },
  'design-works': {
    type: 'staff',
    title: 'デザインワークス',
    name: '奥田明世・清水慶太・石橋翔祐'
  },
  'tanji': {
    type: 'staff',
    title: 'コンセプトデザイン',
    name: '丹地陽子'
  },
  'masuyama': {
    type: 'staff',
    title: '副監督',
    name: '益山亮司'
  },
  'takeda': {
    type: 'staff',
    title: '美術監督',
    name: '竹田悠介'
  },
  'fujii': {
    type: 'staff',
    title: '美術設定',
    name: '藤井一志'
  },
  'kobari': {
    type: 'staff',
    title: '色彩設計',
    name: '小針裕子'
  },
  'izumida': {
    type: 'staff',
    title: '撮影監督',
    name: '出水田和人'
  },
  'imai': {
    type: 'staff',
    title: '編集',
    name: '今井大介'
  },
  'yamada': {
    type: 'staff',
    title: '音楽',
    name: 'やまだ豊'
  },
  'hata': {
    type: 'staff',
    title: '音響監督',
    name: 'はたしょう二'
  },
  'chida': {
    type: 'staff',
    title: 'ミュージックエディター',
    name: '千田耕平'
  },
  'wit': {
    type: 'staff',
    title: 'アニメーション制作',
    name: 'WIT STUDIO',
    comment: '信頼する鏑木監督を筆頭に、素晴らしいスタッフが集まってくれました。ゼロから作り上げるオリジナル作品。上がってくる一つ一つにとても興奮しています。この作品は「世界を股に掛けた百戦錬磨の詐欺師たちの痛快娯楽活劇」。古沢さんの物語で、貞本さんのキャラが大暴れします。WIT STUDIO渾身の新作。皆様、ご期待ください！'
  },
  'kobayashi': {
    type: 'cast',
    title: '枝村真人役',
    name: '小林千晃',
    image: '/assets/images/cast-kobayashi.jpg',
    comment:
      '<p class="q">ー演じられているキャラクターの魅力を教えてください。</p>' +
      '<p>詐欺師であるにも関わらず、人を信じやすく情に厚いという、ちぐはぐな人生を送っている青年です。それ故に騙されやすいのですが、騙し騙される物語の中で、その真っ直ぐな心で足掻きもがく泥臭さが魅力的だと思います。</p>' +
      '<p class="q">ー作品の見どころを教えてください。</p>' +
      '<p>誰がどう騙して、どこまでが真実なのか！？毎回台本を渡される度にキャスト陣も感嘆の声を上げてしまう、緻密に練り込まれたシナリオは、老若男女問わず楽しめること間違いなしです。アニメ史に残る伏線回収を是非堪能して頂きたいです！</p>'
  },
  'suwabe': {
    type: 'cast',
    title: 'ローラン・ティエリー役',
    name: '諏訪部順一',
    image: '/assets/images/cast-suwabe.jpg',
    comment:
      '<p class="q">ー演じられているキャラクターの魅力を教えてください。</p>' +
      '<p>演者としては、もはや客観視出来ないので、彼の魅力について語ることは難しいです。 とりあえず、観てのお楽しみ！ということで。しかし、観た通りの人物なのか？それとも…（笑）</p>' +
      '<p class="q">ー作品の見どころを教えてください。</p>' +
      '<p>いろいろ話すと面白さが薄れると思いますので、とにかく観てのお楽しみ！ということで。その価値のある作品であることは間違いないと思います！大切なことなのでもう一回言っておきます。観る価値ありの作品です！</p>'
  },
  'fujiwara': {
    type: 'cast',
    title: 'アビゲイル・ジョーンズ役',
    name: '藤原夏海',
    image: '/assets/images/cast-fujiwara.jpg',
    comment:
      '<p class="q">ー演じられているキャラクターの魅力を教えてください。</p>' +
      '<p>潜入する際に、ターゲットの懐に入るため毎回違うキャラになりきることができるのが魅力的だと思います。それでいて普段は一見クールな子かと思いきや、ご飯をもりもり食べたり、身体能力が凄まじかったりとそのギャップも素敵だなぁと感じます。演じていてもとても楽しいです。 </p>' +
      '<p class="q">ー作品の見どころを教えてください。</p>' +
      '<p>とにかく1話1話がとても密度の濃いお話になっていて、キャラクターたちが物語の中で騙し騙されていく中で、同時に演者である私たちもいい意味で騙された気分になる瞬間が所々に散りばめられているので、見てくださる皆様にも、良い意味で騙された瞬間を楽しんでいただけたらと思います。</p>'
  },
  'sonozaki': {
    type: 'cast',
    title: 'ポーラ・ディキンス役',
    name: '園崎未恵',
    image: '/assets/images/cast-sonozaki.jpg',
    comment:
      '<p class="q">ー演じられているキャラクターの魅力を教えてください。</p>' +
      '<p>ポーラ・ディキンスは遣り手のFBI特別捜査官。ロス市警やマフィアファミリーを相手に、クールで物怖じしない堂々とした態度は、演じていて清々しさすら感じます。 どんな攻防が繰り広げられるのか。ご期待下さい！</p>' +
      '<p class="q">ー作品の見どころを教えてください。</p>' +
      '<p>カラフルでスタイリッシュな画面に、まず目を奪われることと思います。そして次々展開される物語は、まるで映画を観ているよう！ ローラン達の騙しのテクニックとエダムラの人情に、きっと続きが気になるはずです。</p>'
  }
}



// WEBPACK FOOTER //
// ./src/data/staff.js